module.exports = __webpack_public_path__ + "static/media/stuka.7c2c610b.jpg";